import React, {Component} from "react"
import PropTypes from "prop-types"

export default class NRTTextArea extends Component {

    focus() {
        this.input.focus()
    }


    handleChange = (evt) => {
        this.props.onChange(evt.target.value)
    }


    render() {

        const value = this.props.value || ''

        return (
            <textarea

                rows="4" cols="50"
                ref={input => this.input = input}
                {...this.props}
                value={value}
                onChange={this.handleChange}
            />
        )
    }
}

NRTTextArea.propTypes = {
    style: PropTypes.object,
}

NRTTextArea.defaultProps = {
    style: {},
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/TextAreaInput/index.js